var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights, spacing } from 'syf-component-library/defaultTheme';
import { query } from '../../../const/customBreakPoints';
import { colors } from '../../../../../ui/theme';
var CERTIFICATE_STATUS_STYLES = {
    USED: {
        fontColor: colors.mughalGreen,
        backgroundColor: colors.nyanza
    },
    EXPIRED: {
        fontColor: colors.error,
        backgroundColor: colors.lavenderBlush
    }
};
export var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 24px;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", ";\n  margin-right: 36px;\n  padding: 0 ", "px;\n\n  @media ", " {\n    margin-right: ", "px;\n  }\n"], ["\n  border-radius: 24px;\n  color: ", ";\n  background-color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  line-height: ", ";\n  margin-right: 36px;\n  padding: 0 ", "px;\n\n  @media ", " {\n    margin-right: ", "px;\n  }\n"])), function (_a) {
    var $statusType = _a.$statusType;
    return CERTIFICATE_STATUS_STYLES[$statusType].fontColor;
}, function (_a) {
    var $statusType = _a.$statusType;
    return CERTIFICATE_STATUS_STYLES[$statusType].backgroundColor;
}, fontSizes.small, fontWeights.semiBold, lineHeights.largest, spacing.small, query.lessThanMedium, spacing.base);
var templateObject_1;
